import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GetCard from "../cards/GetCard";
function Home(props) {
  return (
    <>
      <section className='home-area'>
         <Container>
            <Row className='g-4'>
               <Col xl={4}>
                  <GetCard variant='profile'/>
               </Col>
               <Col xl={4}>
                  <Row className='g-4'>
                     <Col lg={12}>
                        <GetCard variant='experience'/>
                     </Col>
                     <Col lg={12}>
                        <GetCard variant='expertise'/>
                     </Col>
                  </Row>
               </Col>
               <Col xl={4}>
                  <GetCard variant='project' showAll={false}/>
               </Col>
               <div className='services-area'>
                  <Row className='g-4'>
                     <Col xl={8} >
                        <GetCard variant='services' showAll={false}/>
                     </Col>
                     <Col xl={4} >
                        <GetCard variant='contact'/>
                     </Col>
                  </Row>
                  
               </div>
            </Row>
         </Container>
      </section>
    </>
   );
 }
 export default Home; 